export default (func) => {
  let throttle = Date.now();
  return (...args) => {
    if ((throttle + 1000 - Date.now()) < 0) {
      throttle = Date.now();
      func(...args);
    }
  };
};
